import { Slot, Slottable } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from 'designSystem/lib/utils'
import type { ComponentProps } from 'react'

const resizeHandleVariants = cva(
  'relative flex w-3 shrink-0 touch-none items-center justify-center cursor-col-resize after:absolute after:inset-y-0 after:left-1/2 after:w-px after:-translate-x-1/2 focus-visible:outline-hidden focus-visible:ring-1 aria-[orientation=horizontal]:h-3 aria-[orientation=horizontal]:w-full aria-[orientation=horizontal]:cursor-row-resize aria-[orientation=horizontal]:after:inset-y-auto aria-[orientation=horizontal]:after:left-0 aria-[orientation=horizontal]:after:top-1/2 aria-[orientation=horizontal]:after:h-px aria-[orientation=horizontal]:after:w-full aria-[orientation=horizontal]:after:translate-x-0 aria-[orientation=horizontal]:after:-translate-y-1/2 [&[aria-orientation=horizontal]>span]:rotate-90',
  {
    variants: {
      size: {
        default: '[&>span]:h-12 [&>span]:w-1.5',
        compact: '[&>span]:h-8 [&>span]:w-1.25',
      },
      tone: {
        default: 'after:bg-border focus-visible:ring-ring',
        muted:
          'z-3 after:bg-sidebar-border focus-visible:ring-inset focus-visible:ring-sidebar-ring hover:after:bg-sidebar-ring data-[resizing=true]:after:bg-sidebar-ring hover:[&>span]:bg-sidebar-ring data-[resizing=true]:[&>span]:bg-sidebar-ring',
      },
    },
    defaultVariants: { size: 'default', tone: 'default' },
  }
)

export function ResizeHandle({
  asChild = false,
  children,
  className,
  size,
  tone,
  ...props
}: ComponentProps<'div'> &
  VariantProps<typeof resizeHandleVariants> & { asChild?: boolean }) {
  const Component = asChild ? Slot : 'div'
  return (
    <Component
      className={cn(resizeHandleVariants({ size, tone }), className)}
      {...props}>
      <Slottable>{children}</Slottable>
      <span
        aria-hidden='true'
        className='z-10 shrink-0 rounded-full bg-input'
      />
    </Component>
  )
}
